export default __webpack_public_path__ + "static/media/communication.4563b2d5.svg";